import http from './http';
import {ENUMS} from "../services/enums";

export default {
  all() {
    return http().get(`/v1/call_scripts`);
  },
  get(id) {
    return http().get(`/v1/call_scripts/${id}`);
  },
  create(data) {
    if (data.type === ENUMS.CallScriptTypeEnum.Contact.value) {
      return http().post(`/v1/call_scripts/contact`, data);
    } else {
      return http().post(`/v1/call_scripts/lead`, data);
    }
  },
  clone(id) {
    return http().post(`/v1/call_scripts/${id}/clone`);
  },
  setDefault(id) {
    return http().post(`/v1/call_scripts/${id}/set-default`);
  },
  update(data) {
    if (data.type === ENUMS.CallScriptTypeEnum.Contact.value) {
      return http().put(`/v1/call_scripts/${data.id}/contact`, data);
    } else {
      return http().put(`/v1/call_scripts/${data.id}/lead`, data);
    }
  },
  patchIdentifier(id) {
    return http().put(`/v1/call_scripts/${id}/identifier`);
  },
  patchRecord(recordId, data) {
    return http().put(`/v1/call_scripts/${recordId}/update-record`, data);
  },
  delete(id) {
    return http().delete(`/v1/call_scripts/${id}`);
  },

  /**
   * Public routes
   */
  getByIdentifier(identifier) {
    return http().get(`/v1/script/${identifier}`);
  },
  submit(data) {
    return http().post(`/v1/script`, data);
  }
}
